





















import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'
import ClippingImage from '@/components/ClippingImage.vue'

@Component({
    components: {
        ClippingImage,
    },
})
export default class UploadButton extends Vue {
    $refs!: {
        inputRef: any
    }

    @Prop({default: false}) disabled!: boolean

    @Prop({default: ''}) label!: string

    @Prop({default: 'image/png, image/jpeg, image/jpg'}) accept!: string

    clippingVisible: boolean = false

    clippingFile: any = ''

    click() {
        this.$refs.inputRef.click()
    }

    change() {
        this.clippingFile = window.URL.createObjectURL(this.$refs.inputRef.files[0])
        this.clippingVisible = true
    }

    clippingDone(file) {
        this.$emit('change', this.$refs.inputRef, file)
    }
}
